import React, { useEffect, useState, useMemo, useRef } from 'react';
import moment from 'moment';

import * as QA from 'shared/utils/queryAnalysis'
import { useConversion } from 'src/components/base/fields/utils';

import { SubstitutionPicker, classNames } from 'src/components/base/fields/SubstitutionPicker';
import { useSubstitutionPicker } from 'src/components/base/fields/utils';


export const Format = {
  Date: 'YYYY-MM-DD',
  Time: 'HH:mm:ss.SSS',
  DateTime: 'YYYY-MM-DDTHH:mm:ss.SSS',
};

export const Mode = {
  AsIs: 'as-is',
  Utc: 'utc',
  Local: 'local',
};

export const Errors = {
  Time: 'Invalid time',
  Date: 'Invalid date',
};


export const TextConverters = { 
  parse: (text, formatString, errorString) => {
    const value = stringToMoment(text, formatString);
    const error = value.isValid() ? '' : errorString;
    return { value, error };
  },
  format: (momentValue, formatString, errorString) => {
    const error = momentValue.isValid() ? '' : errorString;
    const value = momentToString(momentValue, formatString);
    return { value, error };
  }, 
  getDefault: getDefaultValue,
};


export function getDefaultValue() {
  return moment();
}


export function stringToMoment(value, fmt, mode = Mode.Local) {
  return mode === Mode.Utc
    ? moment.utc(value, fmt, true)
    : moment(value, fmt, true);
}

export function momentToString(value, fmt, mode = Mode.AsIs) {
  const v = mode === Mode.Utc 
    ? value.clone().utc() 
    : mode === Mode.Local ? value.clone().local() : value;
  return v.format(fmt);
}

export function jsDateToMoment(date) {
  return moment.utc({ year: date.getFullYear(), month: date.getMonth(), day: date.getDate() });
}

export function mergeMoments(date, time) {
  return moment({ ...getTimePart(time), ...getDatePart(date) });
}

export function splitMoment(dateTime) {
  return { time: dateTime.clone(), date: dateTime.clone() };
}

export function getTimePart(value) {
  return {
    hour: value.hour(),
    minute: value.minute(),
    second: value.second(),
    millisecond: value.millisecond(),
  };
}

export function getDatePart(value) {
  return {
    year: value.year(),
    month: value.month(),
    date: value.date(),
  };
}


export function WithPicker({ component: Component, componentProps, converterProps }) {
  const { converters, ...props } = componentProps;

  const c = mergeConverters(converters, converterProps);
  const res = useConversion(props, c);
  const sProps = useSubstitutionPicker(props);

  return (
    <div className={classNames.withTargetPicker}>
      <Component {...props} {...res} /> 
      <SubstitutionPicker {...sProps} />
    </div>
  );
}

export function mergeConverters(converters, { formatString, errorString }) {
  const { 
    parse = (text, parseSubstitution) => TextConverters.parse(text, formatString, errorString),
    format = (momentValue, parseSubstitution) => TextConverters.format(momentValue, formatString, errorString), 
    getDefault = TextConverters.getDefault
  } = converters ?? {};
  return { parse, format, getDefault };
}